import { HttpImageLoaderService } from './../../image-store/http-image-loader/http-image-loader.service';
import { EventDistributeService } from './../../ng3/event-distribute/event-distribute.service';
import { CanvasService } from './../../ng3/components/canvas.service';
import { CrossLine } from './../../cross-line/cross-line.component';
import { ZStoreService } from './../../ng3/z-store.service';
import { EntityStoreService } from './../../entity-store/entity-store.service';
import { ImageWindow } from './../../image-slice-show/share/model';
import { GrayImage3 } from './../../image-slice-show/share/image';
import { Colormap } from './../../image-slice-show/share/colormap';
import { SliceDirection } from './../../image-slice-show/share/slice';
import { ImageStoreService } from './../../image-store/image-store.service';
import { Component, OnInit } from '@angular/core';
import { MultiCanvasService } from '../multi-canvas.service';
import { Vector3, PerspectiveCamera, Vector2 } from 'three';
import { RendererService } from '../../ng3/components/renderer.service';
import { SceneService } from '../../ng3/components/scene.service';
import { dummyGrayImage } from '../../image-store/http-image-loader/image.debug.repository';
@Component({
  selector: 'app-toolbox',
  templateUrl: './toolbox.component.html',
  styleUrls: ['./toolbox.component.css'],
  providers: [RendererService, SceneService, CanvasService],
})
export class ToolboxComponent implements OnInit {
  selectedImages$ = this.service.selectedImages$;
  readonly whichDraging = this.eventDistribution.eventHandler;
  readonly fovHnadler = this.eventDistribution.fovHandler;
  camera = new PerspectiveCamera();
  constructor(
    private service: MultiCanvasService,
    private imageStoreService: ImageStoreService,
    private entityStoreService: EntityStoreService,
    private renderer: RendererService,
    private eventDistribution: EventDistributeService,
    private loadService: HttpImageLoaderService
    ) {}

    loadInput() {
      this.service.mapSelectedCanvas(c => this.service.loadToCanvas(c, this.loadService.image3Input));
    }
  loadTomo() {
    // this.imageStoreService.grayImage2Subject.next(dummyGrayImage(
    //   new Vector2(60, 60),
    //   new Vector2(60, 60),
    // ));
  }
  changeDirection(d: SliceDirection) {
    this.service.mapSelectedCanvas(c => {
      this.service.mapOnCanvas(c, image =>
        this.imageStoreService.updateDirection(image, d),
      ),
        this.entityStoreService.crosslineOnCanvas(c, crossline => {
          this.entityStoreService.updateCrosslineEntity({
            canvasId: c,
            model: {
              ...crossline,
              view: d,
            },
          });
        });
    });
  }
  dragRing() {
    this.eventDistribution.dragRing();
  }
  dragLine() {
    this.eventDistribution.dragLine();
  }
  dragCrossline() {
    this.eventDistribution.dragCrossline();
  }
  dragFov1() {
    this.eventDistribution.dragFov1();
  }
  dragFov2() {
    this.eventDistribution.dragFov2();
  }
  dragFov3() {
    this.eventDistribution.dragFov3();
  }
  addToolRing() {
    this.service.mapSelectedCanvas(c => this.entityStoreService.addRing(c));
  }
  copyTool() {
    this.service.mapSelectedCanvas(c => this.entityStoreService.copyEntity(c));
  }
  cutTool() {
    this.service.mapSelectedCanvas(c => this.entityStoreService.cutEntity(c));
  }
  pasteTool() {
    this.service.mapSelectedCanvas(c => this.entityStoreService.pasteEntity(c));
  }
  removeTool() {
    this.service.mapSelectedCanvas(c =>
      this.entityStoreService.removeEntityWithCanvasId(c),
    );
  }
  addCrossLine() {
    this.service.mapSelectedCanvas(c =>
      this.entityStoreService.addCrossLine(c),
    );
  }
  addFov() {
    this.service.mapSelectedCanvas(c => this.entityStoreService.addFov(c));
  }
  changeIndex(index: number) {
    this.service.mapSelectedCanvas(c =>
      this.service.mapOnCanvas(c, image =>
        this.imageStoreService.updateIndex(image, index),
      ),
    );
  }
  changeColormap(cm: Colormap) {
    this.service.mapSelectedCanvas(c =>
      this.service.mapOnCanvas(c, image =>
        this.imageStoreService.updateColormap(image, cm),
      ),
    );
  }
  changeWidthLevel(widthlevel: ImageWindow) {
    this.service.mapSelectedCanvas(c =>
      this.service.mapOnCanvas(c, image =>
        this.imageStoreService.updateWidthLevelFilter(
          image,
          widthlevel.width,
          widthlevel.level,
        ),
      ),
    );
  }
  imageLoad(image: GrayImage3) {
    this.service.mapSelectedCanvas(c => this.service.loadToCanvas(c, image));
  }
  rotate_plane() {
    this.service.mapSelectedCanvas(c =>
      this.service.mapOnCanvas(
        c,
        image =>
          this.imageStoreService.addRotation(
            image,
            new Vector3(0, 0, Math.PI / 2),
          ),
        // this.imageStoreService.update({rotate: image.rotate + Math.PI/2, ...image}),
      ),
    );
  }
  showEntitiesofCanva() {
    this.service.mapSelectedCanvas(c =>
      this.entityStoreService
        .entitiesOfCanvas(c)
        .subscribe(a => console.log(a)),
    );
  }
  showEntities() {
    this.entityStoreService
      .showEntities()
      .subscribe(a => console.log('all', a));
    this.entityStoreService
      .showClipBoard()
      .subscribe(a => console.log('clip board', a));
    this.service.mapSelectedCanvas(c =>
      this.entityStoreService
        .entitiesOfCanvas(c)
        .subscribe(a => console.log('entitiesOfCanvas', a)),
    );
  }
  showCanvas() {
    console.log(this.service.componentCanvasSubject.value);
  }
  ngOnInit() {}
}
